import React, { Component } from 'react';
import './sr-only.css';
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Box } from "grommet/components/Box";
import { Text } from "grommet/components/Text";
import { TextInput } from "grommet/components/TextInput";
import { Button } from "grommet/components/Button";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { RadioButton } from "grommet/components/RadioButton";
//import Pagination from "./../Components/Pagination";
import MainButtons from "../Components/MainButtons.js";
import { SearchPointOfSalesCtrl } from "../Controllers/Transaction/SearchPointOfSalesCtrl";
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { sessionExpired } from '../Utils/Utility';

//code = codice societario, it has been set in the session storage whenever the tab is on 'singolo punto vendita', when the page is realoded and the tab switched to 'tutti i punti vendita' the code will be removed from the session.

class Home extends Component {
  static propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object
  };
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      status:'',
      search: '',
      value: !sessionStorage.getItem("i") ? null : parseInt(sessionStorage.getItem("i")),
      selected: !sessionStorage.getItem("i") ? null : parseInt(sessionStorage.getItem("i")),
      dataRequest: "",
      tab: "",
      isDisabled: false,
      tablePointofSales: [],
      pages: 0,
      currentPage: 1,
      showTimeoutModal: false,
      openInfo: !sessionStorage.getItem('msg') ? true : false
      //lo stato isDisabled corrisponde alla profilazione dell'utente, se si tratta di un singolo punto vendita è settato su true se no false
    };

    this.setSearch = this.setSearch.bind(this);
    this.renderReactTable = this.renderReactTable.bind(this);
    this.changeSelect = this.changeSelect.bind(this);
    this.closeMsgInfo = this.closeMsgInfo.bind(this);
    this.getPointOfSales = this.getPointOfSales.bind(this);
    this.keepAlive = this.keepAlive.bind(this);
  }

  componentDidMount(i) {
    var token = sessionStorage.getItem('token')
    var ids = sessionStorage.getItem('ids')
    const self = this;
    const {history} = this.props;
    SearchPointOfSalesCtrl(function (data, pages, currentPage) {
      self.setState({
        tablePointofSales: data === undefined ? [] : data,
        pages: pages === undefined ? 0 : pages,
        //currentPage: currentPage === undefined ? [] : currentPage
      });
    }, function (error) {
      self.setState({
        status: error
    }, function(){
      if(error === 401 || error === 408){
        self.setState({
            showTimeoutModal: true
        })
    } else{
        history.push({
            pathname: '/ErrorPage'
        });
    }
    })

    }, token, ids, this.state.currentPage, this.state.search);

    // settare gli stati di default della tab, 'i' è la index della row

    if (this.state.tab === "" && !sessionStorage.getItem("code") && !sessionStorage.getItem("i")) {
      this.setState({ tab: 0, tabActive0: "tabActive" });
      sessionStorage.setItem("tab", 0);
    } else if (sessionStorage.getItem("tab") === "1" && sessionStorage.getItem("code")) {
      this.setState({
        tab: 1,
        tabActive1: 'tabActive',
        value: parseInt(sessionStorage.getItem("i")),
        selected: parseInt(sessionStorage.getItem("i"))
      });
    } else if (sessionStorage.getItem("tab") === "0" && sessionStorage.getItem('i') && sessionStorage.getItem('code')) {
      this.setState({
        tab: 0,
        tabActive1: "",
        tabActive0: "tabActive"
      });
      sessionStorage.setItem("tab", 0);
      sessionStorage.removeItem("code");
      sessionStorage.removeItem("i");
    }
  }

  keepAlive() {
    var token = sessionStorage.getItem('token')
    var ids = sessionStorage.getItem('ids')
    const self = this;

    sessionExpired(function (data) {
        self.setState({
            data: data === '' ? [] : data
        });
    }, function (error) {
        self.setState({
            status: error
        }, function(){
            if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                this.props.history.push({
                    pathname: '/ErrorPage',
                    state: this.state
                })  
            } else if (this.state.status === 401) {
                this.setState({
                    showTimeoutModal: true
                })
            } 
        })

    }, token, ids);
}

  closeMsgInfo() {
    this.setState({
      openInfo: false
    })
    sessionStorage.setItem('msg', false)
  }

  setPoint(i) {
    sessionStorage.setItem("i", i);
    if (sessionStorage.getItem("i", i)) {
      this.setState({
        value: parseInt(sessionStorage.getItem("i", i)),
        selected: parseInt(sessionStorage.getItem("i", i))
      });
    } else {
      this.setState({ value: null });
    }
    sessionStorage.setItem("code", this.state.tablePointofSales[i].code);
  }

  setSearch(event) {
    this.setState({
      search: event.target.value
    });
  }

  changeSelect(index) {
    if (this.state.tab === "" && !sessionStorage.getItem("code")) {
      this.setState({ tab: 0 });
      sessionStorage.setItem("tab", 0);
    } else if (index === 1) {
      this.setState({
        tab: 1,
        value: parseInt(sessionStorage.getItem("i")),
        selected: parseInt(sessionStorage.getItem("i")),
        tabActive0: "",
        tabActive1: "tabActive"
      });
      sessionStorage.setItem("tab", 1);
    } else if (index === 0 && sessionStorage.getItem('i') && sessionStorage.getItem('code')) {
      this.setState({
        tab: 0,
        tabActive1: "",
        tabActive0: "tabActive"
      });
      sessionStorage.setItem("tab", 0);
      sessionStorage.removeItem("code");
      sessionStorage.removeItem("i");
    }
    else if (index === 0) {
      this.setState({
        tab: 0,
        tabActive1: "",
        tabActive0: "tabActive"
      });
      sessionStorage.setItem("tab", 0);

    }
  }
  
  prevPage(){
    sessionStorage.removeItem('i');
    let cp = this.state.currentPage;
    if (cp === 1) return;
    this.setState({
      currentPage: cp - 1
    },() => {
      this.getPointOfSales();
    });
  }

  nextPage(){
    sessionStorage.removeItem('i');
    let cp = this.state.currentPage;
    if (cp === this.state.pages) return;
    this.setState({
      currentPage: cp + 1
    },() => {
      this.getPointOfSales();
    });
  }

  renderReactTable() {
    const columns = [
      {
        Header: "",
        accessor: "",
        Cell: row => (
          <div>
            <RadioButton
              id={"radio" + [row.index]}
              className="radiobutton"
              checked={this.state.selected === row.index ? true : false}
              onChange={this.setPoint.bind(this, row.index)}
              value={row.index}
            />
          </div>
        ),
        maxWidth: 60
      },
      {
        Header: "INSEGNA",
        accessor: "name"
      },
      {
        Header: "CODICE ESERCIZIO",
        accessor: "code"
      },
      {
        Header: "INDIRIZZO",
        accessor: "address"
      },
      {
        Header: "CITTÀ",
        accessor: "city"
      }
    ];

    return (
      <Box>
        {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
        <ReactTable
          data={this.state.tablePointofSales}
          columns={columns}
          sortable={true}
          multiSort={true}
          resizable={true}
          showPagination={false}
          loading={false}
          defaultPageSize={10}
        />
        <div>
          <div style={{height: '50px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
  {/* PREVIOUS PAGE */}
  <button
    type="button"
    style={{width: '20px', height: '30px', color: this.state.currentPage === 1 ? '#999' : '#006fcf', cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer', background: 'none', border: 'none', padding: 0}}
    onClick={() => this.prevPage && this.prevPage()}
    aria-label="Pagina precedente"
    disabled={this.state.currentPage === 1}
  >
    <i className='icon-left-chevron' style={{fontSize:'24px', fontStyle:'normal'}} aria-hidden="true"></i>
    <span className="sr-only">Pagina precedente</span>
  </button>

  {/* POSITION PAGE */}
  <Text className='pag' style={{fontSize:'12px', marginLeft: '8px', marginRight: '8px'}}>
    {this.state.currentPage} di {this.state.pages}
  </Text>

  {/* NEXT PAGE */}
  <button
    type="button"
    style={{width: '20px', height: '30px', color: this.state.currentPage === this.state.pages ? '#999' : '#006fcf', cursor: this.state.currentPage === this.state.pages ? 'not-allowed' : 'pointer', background: 'none', border: 'none', padding: 0}}
    onClick={() => this.nextPage && this.nextPage()}
    aria-label="Pagina successiva"
    disabled={this.state.currentPage === this.state.pages}
  >
    <i className='icon-right-chevron' style={{fontSize:'24px', fontStyle:'normal'}} aria-hidden="true"></i>
    <span className="sr-only">Pagina successiva</span>
  </button>
</div>
        </div>
      </Box>
    );
  }


  getPointOfSales() {
    var token = sessionStorage.getItem('token')
    var ids = sessionStorage.getItem('ids')
    const self = this;
    SearchPointOfSalesCtrl(function (data, pages, currentPage) {
      self.setState({
        tablePointofSales: data === undefined ? [] : data,
        pages: pages === undefined ? 0 : pages,
        //currentPage: currentPage === undefined ? [] : currentPage
      });
    }, function (error) {
      self.setState({
        status: error
      }, function() {
        if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
          this.props.history.push({
              pathname: '/ErrorPage',
              state: this.state
          })  
      } else if (this.state.status === 401) {
        this.setState({
          showTimeoutModal: true
        })
          // logout();
          // this.props.history.push({
          // pathname: '/login'
          // })
      } 
      })

    }, token, ids, this.state.currentPage, this.state.search);
  }

  render() {

    return (
      <Box>
          {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
        <Box
          align="center"
          className="content"
          style={{ backgroundColor: "#f9f9f9", marginTop: "0" }}
        >
          <Box className="contentbox">
            <Box pad="medium" align="start" style={{ paddingBottom: "50px" }}>
              <Text className="titlehome">
                <h1>Consulta movimenti, contestazioni, riepiloghi e statistiche
                online</h1>
              </Text>
              <Text style={{ textAlign: 'left' }}>
                <h3>Consulta i dati dei punti vendita che hanno effettuato
                transazioni negli ultimi 13 mesi!</h3>
              </Text>
            </Box>

            <div className="contentbox-menu">
              <br />
              { sessionStorage.getItem("codSocietario") === '1' ?
                <Tabs
                  selectedIndex={this.state.tab}
                  selectedTabClassName="react-tabs__tab--selected SEL"
                  onSelect={index => {
                    this.changeSelect(index);
                  }}
                >
                  <TabList>
                    <Tab onClick={() => this.keepAlive}>
                      <h4 className={`tabInactive ${this.state.tabActive0}`}>
                        Tutti i punti vendita
                      </h4>
                    </Tab>
                    {this.state.isDisabled ? null : (
                      <Tab onClick={() => this.keepAlive}>
                        <h4 className={`tabInactive ${this.state.tabActive1}`}>
                          Singolo punto vendita
                        </h4>
                      </Tab>
                    )}
                  </TabList>

                  <TabPanel>
                    <Box>
                      <MainButtons />
                    </Box>
                  </TabPanel>
                  <TabPanel>
                    <Box style={{ borderBottom: "1px solid #C8C9C7" }}>
                      <MainButtons />
                    </Box>
                    <Box pad="large">
                      <Text className="description"><h5>
                        Affina la ricerca digitando: iniziali insegna/codice
                        esercizio (o anche parziale)</h5>
                      </Text>
                    </Box>
                    <Box align="center">
                      <Box direction="row" id='mrg' className="searchbox">
                        <TextInput
                          id="search"
                          className="inputSearch"
                          value={this.state.search}
                          placeholder=""
                          onChange={this.setSearch}
                          aria-label="Ricerca punto vendita"
                        />
                        <Button className="btnsearchhome" onClick={this.getPointOfSales} a11yTitle='Ricerca per singolo punto vendita'>
                          <span role="img" aria-label="Cerca">
                            <i
                              className="icon-magnifying-glass"
                              style={{ fontSize: "22px", verticalAlign:'-webkit-baseline-middle' }}
                              aria-hidden="true"
                            />
                          </span>
                        </Button>
                      </Box>
                    </Box>

                    <Box style={{ margin: "50px 24px" }}>
                      {this.renderReactTable()}
                    </Box>
                  </TabPanel>
                </Tabs> : 

                <Tabs
                  selectedTabClassName="react-tabs__tab--selected SEL"
                >
                  <TabList>
                      <Tab onClick={this.keepAlive}>
                        <h4 className={`tabInactive tabActive0`}>
                          Il tuo punto vendita
                        </h4>
                      </Tab>
                  </TabList>

                  <TabPanel>
                    <Box>
                      <MainButtons />
                    </Box>
                  </TabPanel>
                </Tabs>

              }
            </div>
          </Box>
        </Box>
      </Box >
    );
  }
}
export default Home = withRouter(Home);
